// Application Constants
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'CHUB'
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '0.1.0'
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api'
export const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT) || 30000

// Route Constants
export const ROUTES = {
	HOME: '/',
	ABOUT: '/about',
	// Add more routes as needed
}

// HTTP Status Codes
export const HTTP_STATUS = {
	OK: 200,
	CREATED: 201,
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	INTERNAL_SERVER_ERROR: 500,
}

// Local Storage Keys
export const STORAGE_KEYS = {
	TOKEN: 'auth_token',
	USER: 'user_data',
	THEME: 'app_theme',
}

// Common Regex Patterns
export const REGEX = {
	EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
	PHONE: /^\+?[\d\s-()]+$/,
	URL: /^https?:\/\/.+/,
}
